import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Loading from '../MyItems/Loading';

export default function MyListings() {


  return (
    <div className="p-6">
      <h1 className="text-3xl font-company text-pink-700 text-center font-bold mb-4">Unavailable for demo</h1>
    </div>
  );
}